import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter, finalize } from 'rxjs/operators';
/*import { GridOptions, ColDef, AllModules, IDateFilterParams, ITextFilterParams } from '@ag-grid-enterprise/all-modules';*/
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

import { RouterLinkRendererComponent } from '../ag-grid/router-link-renderer.component';
import { ModalInfoComponent } from "../ag-grid/modal-info.component";
import { FlowIndex } from '../../models/flow.dto';
import { WorkOrderStatus } from '../../models/work-order.model';
import { FinancialAssuranceService } from '../../services/financial-assurance.service';
import { FlowInstanceService } from '../../../flow/services/flow-instance.service';
import { dateComparator, dateFilterComparator } from '../data-table/comparators/data-table.comparators';
import { GridFormatterService } from '../../services/grid-formatter.service';


@Component({
    selector: 'fa-not-submitted-flow',
    templateUrl: './fa-not-submitted-flow.component.html',
    styleUrls: ['./fa-not-submitted-flow.component.scss'],
    standalone: false
})
export class FinancialAssuranceNotSubmittedFlowComponent implements OnInit, OnDestroy {

    @Input() public externalView: boolean = true;
    @Input() public orgId: string;
    @Input() gridAriaLabel: string;

    columnApplicationNumber: ColDef = {
        headerClass: "wrapped",
        headerName: 'Application Number',
        headerTooltip: 'Application Number',
        field: 'flowIdentifier',
        cellRendererSelector: (params) => {
            if (params.data.onBehalf) {
                return {
					component: ModalInfoComponent,
                    params: {
                        modalText: (data) => { return `Application ${data.flowIdentifier} is a paper submission that must be completed by ODNR.`; },
                        text: (data) => { return data.flowIdentifier; }
                    }
                }
            } else {
                return {
					component: RouterLinkRendererComponent,
                    params: {
                        textField: 'flowIdentifier',
                        flowIdField: 'flowId'
                    }
                }
            }
        },
        tooltipField: 'flowIdentifier',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        minWidth: 130
    }

    columnCreatedBy: ColDef = {
        headerClass: "wrapped",
        headerName: 'Created By',
        headerTooltip: 'Created By',
        tooltipField: 'userName',
        field: 'userName',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
    };

    columnDateCreated: ColDef = {
        headerClass: "wrapped",
        headerName: 'Started',
        headerTooltip: 'Started',
        tooltipValueGetter: this.formatterService.formatDate('createdDate'),
        field: 'createdDate',
        valueGetter: this.formatterService.formatDate('createdDate'),
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        maxWidth: 150
    };

    columnFlowName: ColDef = {
        headerClass: "wrapped",
        headerName: 'Type',
        headerTooltip: 'Type',
        tooltipField: 'name',
        field: 'name',
        maxWidth: 135
    };

    columnStatus: ColDef = {
        headerClass: "wrapped",
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: this.statusFormatter(this),
        field: 'status',
        valueGetter: this.statusFormatter(this),
        maxWidth: 130
    };

    data: FlowIndex[];
	gridOptions: GridOptions;
	gridApi?: GridApi;
    subscriptions: Subscription = new Subscription();

    notSubmittedColumns = [
        this.columnDateCreated,
        this.columnApplicationNumber,
        this.columnCreatedBy,
        this.columnFlowName,
        this.columnStatus
    ];

    statusEnum = WorkOrderStatus;
    templateIds = FinancialAssuranceService.TemplateIds;

    constructor(
        private formatterService: GridFormatterService,
        public service: FlowInstanceService,
        private router: Router
    ) {

    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    ngOnInit() {

        this.refreshData();
        this.gridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.notSubmittedColumns);
        this.gridOptions.headerHeight = 50;
		this.gridOptions.onGridReady = (params) => { this.gridApi = params.api; };
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    refreshData(): void {
        this.subscriptions.add(this.service.getReturnedIncompleteApplication('FinancialAssuranceNotSubmittedFlows', false, this.orgId).subscribe(
            data => {
                this.data = data.sort((a, b) => a.createdDate > b.createdDate ? 1 : -1);
                this.resizeColumns();
            },
            error => { console.log(error); alert("ERROR Fetching Not Submitted Financial Assurance Applications"); }
        ));
    }

    resizeColumns(): void {
        if (this.gridApi) {
            this.gridApi.sizeColumnsToFit();
        }
    }

    statusFormatter(component) {
        return (obj) => "Not Submitted";
    }

}